import React, { useRef, useEffect, useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styles from './Confirmation.module.scss'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'
import ContactInformation from './ContactInformation'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  // const t = this.props.t
  // const i18n = this.props.i18n
  // const emailAddress = this.props.emailAddress
  // const paymentTransactionNum = this.props.paymentTransactionNum
  const handleGoBackToStart = (e) => {
    e.preventDefault();
    const url = i18n.language === 'en'
      ? process.env.REACT_APP_PAGE_NOT_FOUND_URL
      : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR

    window.location.replace(url);
  }

  return (
    <div className={"container"}>
      <div style={{ display: "flex" }} >
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
          <div className={"col-xs-1 " + styles['success_margin_right']}><i className="fa fa-check-circle fa-2x" aria-hidden="true"></i></div>
          <div style={{ flexGrow: 1, backgroundColor: "green", width: "5px" }} />
        </div>

        <div style={{ flexGrow: 1 }}>
          {/*  */}
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h1 style={{ color: "green" }}>{t('receive_confirmation.title')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h2>{t('receive_confirmation.transaction_number')} <strong>{paymentTransactionNum}</strong></h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <p style={{ marginBottom: '10px' }}>
                  {t('receive_confirmation.we_have_emailed')} <br />
                  {t('receive_confirmation.print_or_save')}
                </p>
              </div>
            </div>

            <div className="print_no_display">
              <div className="row" >
                <div style={{ display: "flex", flexGrow: 1 }} > {/*className="col-xs-12 col-lg-10" */}
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  {/* eslint-disable-next-line */}
                  <a href={"https://beta.novascotia.ca/pay-fine-ticket"} className={styles['all_finished_link']} onClick={handleGoBackToStart}>{t('receive_confirmation.all_finished')}                <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {

  const pageElem = useRef()
  const location = useLocation()

  const [paymentTransactionNum, setPaymentTransactionNum] = useState('')
  const [transId, setTransId] = useState('123456')
  const [transOwner, setTransOwner] = useState('test Test')
  const [emailAddress, setEmailAddress] = useState('')

  // const { payeeContactInformation, contactInformation } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      // dispatch(clearAllAction())
      // dispatch(logoutAction()).catch((e) => {
      //   console.log(e)
      // })
      if (!location.state) {
        return;
      }
      if (location.state.transNum) {
        setPaymentTransactionNum(location.state.transNum)
      }
      if (location.state.emailAddress) {
        setEmailAddress(location.state.emailAddress);
      }
      if (location.state.transId) {
        setTransId(location.state.transId);
      }
      if (location.state.transOwner) {
        setTransOwner(location.state.transOwner);
      }
      if (location.state && location.state.transNum && location.state.emailAddress && location.state.transId && location.state.transOwner) {

        setTransId(location.state.transId)
        setTransOwner(location.state.transOwner)
        setEmailAddress(location.state.emailAddress)
      } else {
        // history.push(`/${i18n.language}${t('routes.privacy_notice')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [location.state, setIsError])

  // const emailStr = useMemo(() => {
  //   return payeeContactInformation ? `${emailAddress} ${t('shared.and')} ${contactInformation.email}` : emailAddress
  // }, [emailAddress, payeeContactInformation, contactInformation, t])

  const moreInformationOnClick = () => {
    window.open('https://beta.novascotia.ca/pay-privilege-reinstatement-fee-registry-motor-vehicles', '_blank')
  }

  return (
    <React.Fragment>
      <div ref={pageElem} style={{ marginBottom: "2rem" }}>
        <PrintContent1 i18n={i18n} t={t} emailAddress={emailAddress} paymentTransactionNum={paymentTransactionNum} transId={transId} transOwner={transOwner} />
        <div className="container">

          <div className="row">
            <div className="col-xs-12 col-md-8">
              <h2>{t('receive_confirmation.what_happens_next')}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.book_road')}</strong>
                  <br />
                  {t('receive_confirmation.call_number')}
                  <br />
                  {t('receive_confirmation.bring_a_copy')}
                  <br></br>
                  <br></br>
                </div>
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.confirmation_email_title')}</strong>
                  <br />
                  {t('receive_confirmation.confirmation_email')}{emailAddress}
                  <br />
                  {t('receive_confirmation.confirmation_email_info')}
                  <br></br>
                  <br></br>
                </div>
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.payment_processed')}</strong>
                  <br />
                  {t('receive_confirmation.your_road_test_payment')}
                  <br />
                  {t('receive_confirmation.charges_will_appear')}
                  <br></br>
                  <br></br>
                </div>
                <div className="col-xs-12">
                  <h2>{t('receive_confirmation.if_you_have_questions')}</h2>
                  {t('receive_confirmation.if_you_have_questions_about')}
                  <br></br>
                  <br></br>
                  <ContactInformation />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment >
  )
}

export default withTranslation('common')(ReceiveConfirmationView)
